<template>
  <!-- badge: resumen para tablas -->
  <span v-if="mode == 'badge'">
    <span v-if="!backups" class="text-muted">—</span>
    <span v-else class="monitor-backups-cell" v-b-tooltip.hover.html :title="tooltip">
      <span :class="backups.ultimo_backup ? 'text-success' : 'text-danger'">
        <AppIcon name="backup" /> {{backups.ultimo_backup ? capitalize(timeAgo(backups.ultimo_backup)) : 'Sin backups todavía'}}
      </span>
      <small :class="next.overdue ? 'text-danger' : 'text-muted'">{{next.label}}</small>
    </span>
  </span>

  <!-- detail: datos completos -->
  <div v-else>
    <div v-if="!backups" class="text-muted">Sin datos reportados</div>
    <div v-else class="monitor-detail">
      <div class="monitor-detail__tiles">
        <div class="monitor-detail__tile" :class="backups.ultimo_backup ? 'monitor-detail__tile--success' : 'monitor-detail__tile--danger'">
          <span class="monitor-detail__tile-label">Último backup</span>
          <span class="monitor-detail__tile-value">{{backups.ultimo_backup ? capitalize(timeAgo(backups.ultimo_backup)) : 'Ninguno todavía'}}</span>
        </div>
        <div class="monitor-detail__tile" :class="{ 'monitor-detail__tile--danger': next.overdue }">
          <span class="monitor-detail__tile-label">Próximo backup</span>
          <span class="monitor-detail__tile-value">{{next.overdue ? 'Vencido' : capitalize(next.short)}}</span>
          <span v-if="next.overdue" class="monitor-detail__tile-meta">hace {{next.duration}}</span>
        </div>
      </div>
      <div class="monitor-detail__row">
        <span class="monitor-detail__label"><AppIcon name="schedule" /> Horario</span>
        <span class="monitor-detail__value">{{backups.horario}} hs</span>
      </div>
      <div class="monitor-detail__row">
        <span class="monitor-detail__label"><AppIcon name="database" /> Tamaño</span>
        <span class="monitor-detail__value">
          <span class="monitor-pill monitor-pill--neutral">Bases {{backups.tamano.bases}}</span>
          <span class="monitor-pill monitor-pill--neutral">Archivos {{backups.tamano.archivos}}</span>
        </span>
      </div>
      <div class="monitor-detail__row monitor-detail__row--top">
        <span class="monitor-detail__label"><AppIcon name="history" /> Históricos</span>
        <span class="monitor-detail__value">{{backups.historicos}} {{backups.historicos == 1 ? 'copia' : 'copias'}}</span>
      </div>
      <div v-if="backups.fecha_actualizacion" class="monitor-detail__footer">
        <AppIcon name="update" /> Relevado {{timeAgo(backups.fecha_actualizacion)}} · {{formatDate(backups.fecha_actualizacion)}}
      </div>
    </div>
  </div>
</template>

<script>
  // formato de monitor_backups (definido con Monitor):
  // {ultimo_backup|null, tamano: {bases, archivos}, horario: HH:MM, proximo_backup, historicos, fecha_actualizacion}
  import { timeAgo, humanDuration, formatDate } from './monitorConfig'
  import './monitorDetail.css'

  export default {
    props: {
      value: { default: null },
      mode: { type: String, default: 'badge' },
    },
    computed: {
      backups() {
        var data = this.value
        if(data === null || data === undefined || data === '') return null
        if(typeof data == 'string') {
          try {
            data = JSON.parse(data)
          } catch (error) {
            return null
          }
        }
        if(!data || typeof data != 'object' || !data.tamano) return null
        return data
      },
      // cuánto falta para el próximo: lo calcula Zyncro a partir de proximo_backup
      next() {
        var date = this.backups ? this.parseDate(this.backups.proximo_backup) : null
        if(!date) return { label: '', overdue: false, duration: '', short: '—' }

        var minutes = Math.round((date.getTime() - Date.now()) / 60000)
        if(minutes < 0) return { label: 'Vencido hace ' + humanDuration(minutes), overdue: true, duration: humanDuration(minutes), short: '' }
        return { label: 'Próximo en ' + humanDuration(minutes), overdue: false, duration: humanDuration(minutes), short: 'en ' + humanDuration(minutes) }
      },
      tooltip() {
        if(!this.backups) return ''
        return [
          '<b>Bases:</b> ' + this.escape(this.backups.tamano.bases),
          '<b>Archivos:</b> ' + this.escape(this.backups.tamano.archivos),
          '<b>Horario:</b> ' + this.escape(this.backups.horario) + ' hs',
          '<b>Históricos:</b> ' + this.escape(this.backups.historicos),
        ].join('<br>')
      },
    },
    methods: {
      timeAgo,
      formatDate,
      parseDate(value) {
        if(!value) return null
        var date = new Date(String(value).replace(' ', 'T'))
        return isNaN(date.getTime()) ? null : date
      },
      capitalize(text) {
        return text ? text.charAt(0).toUpperCase() + text.slice(1) : text
      },
      escape(text) {
        return String(text === undefined || text === null ? '' : text).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])
      },
    }
  }
</script>

<style scoped>
  .monitor-backups-cell {
    display: inline-flex;
    flex-direction: column;
    line-height: 1.3;
    white-space: nowrap;
  }
</style>
